if (!window.QB) {
  window.QB = {
    modal: null,
    productCache: {},
    inventoryCache: {},
    selectedVariant: null,
    currentProduct: null,
    currentProductId: null,
    defaultBtnText: (window.QB_CONFIG && window.QB_CONFIG.defaultBtnText) || 'Add to cart',
    _cartLimit: (window.QB_CONFIG && window.QB_CONFIG.cartLimit) || 5,
    _cartQuantities: {},

    init() {
      if (!document.getElementById('qb-modal')) {
        const template = document.querySelector('#qb-modal-template');
        if (!template) return;
        const node = template.content.cloneNode(true);
        document.body.appendChild(node);
      }
      this.modal = document.getElementById('qb-modal');
      if (!this.modal) return;

      const minusBtn = this.modal.querySelector('.qb-quantity-minus');
      const plusBtn = this.modal.querySelector('.qb-quantity-plus');
      const qtyInput = this.modal.querySelector('.qb-quantity-input');

      minusBtn.addEventListener('click', () => {
        const min = parseInt(qtyInput.min) || 1;
        const current = parseInt(qtyInput.value) || 1;
        if (current > min) qtyInput.value = current - 1;
        minusBtn.disabled = parseInt(qtyInput.value) <= min;
        plusBtn.disabled = false;
      });

      plusBtn.addEventListener('click', () => {
        const max = parseInt(qtyInput.max) || 999;
        const current = parseInt(qtyInput.value) || 1;
        if (current < max) qtyInput.value = current + 1;
        plusBtn.disabled = parseInt(qtyInput.value) >= max;
        minusBtn.disabled = false;
      });

      qtyInput.addEventListener('change', () => {
        const min = parseInt(qtyInput.min) || 1;
        const max = parseInt(qtyInput.max) || 999;
        let val = parseInt(qtyInput.value) || 1;
        if (val < min) val = min;
        if (val > max) val = max;
        qtyInput.value = val;
        minusBtn.disabled = val <= min;
        plusBtn.disabled = val >= max;
      });

      // Quick buy button click
      document.addEventListener('click', (e) => {
        const btn = e.target.closest('.qb-btn');
        if (btn) {
          e.preventDefault();
          e.stopPropagation();
          this.handleClick(btn);
          return;
        }
        const optBtn = e.target.closest('.qb-option-btn');
        if (optBtn && !optBtn.classList.contains('unavailable')) {
          this.selectOption(parseInt(optBtn.dataset.optionIndex), optBtn.dataset.value);
          return;
        }
      });

      // Swatch click — capture phase
      document.addEventListener('click', (e) => {
        const swatch = e.target.closest('[class*="qb-swatch-"]');
        if (!swatch || swatch.classList.contains('qb-overflow')) return;
        e.preventDefault();
        e.stopPropagation();
        if (swatch.dataset.variantAvailable !== 'true') return;
        const wrapper = swatch.closest('[data-product-id]');
        if (!wrapper) return;
        const productId = wrapper.dataset.productId;
        wrapper.querySelectorAll('[class*="qb-swatch-' + productId + '"]').forEach(s => s.classList.remove('selected'));
        swatch.classList.add('selected');
        wrapper.dataset.selectedVariant = swatch.dataset.variantId;
        const qbBtn = document.querySelector('.qb-btn-' + productId);
        if (qbBtn) {
          this.handleClick(qbBtn).then(() => {
            const variantId = swatch.dataset.variantId;
            const productData = this.currentProduct;
            if (productData) {
              const variant = productData.variants.find(v => v.id == variantId);
              if (variant) {
                variant.options.forEach((value, index) => this.selectOption(index, value));
              }
            }
          });
        }
      }, true);

      // Hover prefetch — desktop only
      document.addEventListener('mouseover', (e) => {
        if (window.matchMedia('(max-width: 749px)').matches) return;
        const card = e.target.closest('.card, .product-card, [class*="product-card"]');
        if (!card) return;
        const btn = card.querySelector('.qb-btn');
        if (btn) {
          btn.style.opacity = '1';
          btn.style.visibility = 'visible';
          const handle = btn.dataset.productHandle;
          if (handle && !this.productCache[handle]) {
            fetch('/products/' + handle + '.js')
              .then(r => r.json())
              .then(data => { this.productCache[handle] = data; });
          }
        }
      });

      document.addEventListener('mouseout', (e) => {
        if (window.matchMedia('(max-width: 749px)').matches) return;
        const card = e.target.closest('.card, .product-card, [class*="product-card"]');
        if (!card) return;
        const related = e.relatedTarget;
        if (related && card.contains(related)) return;
        const btn = card.querySelector('.qb-btn');
        if (btn) { btn.style.opacity = '0'; btn.style.visibility = 'hidden'; }
      });

      // Modal close handlers
      this.modal.querySelector('.qb-modal-close').addEventListener('click', () => this.closeModal());
      this.modal.addEventListener('click', (e) => { if (e.target === this.modal) this.closeModal(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.closeModal(); });

      // Modal form submit
      this.modal.querySelector('.qb-form').addEventListener('submit', async (e) => {
        e.preventDefault();
        if (!this.selectedVariant || !this.selectedVariant.available) return;
        const qty = parseInt(this.modal.querySelector('.qb-quantity-input').value) || 1;
        const added = await this.addToCart(this.selectedVariant.id, qty);
        if (added) this.closeModal();
      });
    },

    async handleClick(btn) {
      const handle = btn.dataset.productHandle;
      const variantCount = parseInt(btn.dataset.variantCount);
      const productId = btn.dataset.productId;

      try {
        const inventoryData = JSON.parse(btn.dataset.inventory || '{}');
        this.inventoryCache[productId] = inventoryData;
      } catch(e) {}

      if (!this.productCache[handle]) {
        const res = await fetch('/products/' + handle + '.js');
        this.productCache[handle] = await res.json();
      }

      const productData = this.productCache[handle];

      if (variantCount === 1) {
        // Single variant — add directly, drawer opens inside addToCart
        await this.addToCart(productData.variants[0].id, 1);
      } else {
        const swatchWrapper = document.querySelector('.qb-swatches-' + productId);
        const preSelected = swatchWrapper ? swatchWrapper.dataset.selectedVariant : null;
        this.openModal(productData, preSelected, productId);
      }
    },

    async openModal(productData, preSelectedVariantId, productId) {
      this.currentProduct = productData;
      this.currentProductId = productId;
      this.modal.querySelector('.qb-modal-title').textContent = productData.title;
      this.modal.querySelector('.qb-modal-price').textContent = this.formatMoney(productData.price);

      const qtyInput = this.modal.querySelector('.qb-quantity-input');
      qtyInput.value = 1;
      qtyInput.min = 1;
      qtyInput.max = 999;
      this.modal.querySelector('.qb-quantity-minus').disabled = true;
      this.modal.querySelector('.qb-quantity-plus').disabled = false;

      this._cartQuantities = {};
      try {
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        cart.items.forEach(item => {
          this._cartQuantities[item.variant_id] = (this._cartQuantities[item.variant_id] || 0) + item.quantity;
        });
      } catch(e) {}

      const variantsContainer = this.modal.querySelector('.qb-variants');
      variantsContainer.innerHTML = '';

      productData.options.forEach((option, optionIndex) => {
        if (option.name.toLowerCase() === 'title' && option.values.length === 1) return;

        const group = document.createElement('div');
        group.className = 'qb-option-group';

        const label = document.createElement('label');
        label.className = 'qb-option-label';
        label.textContent = option.name;
        group.appendChild(label);

        const useDropdown = option.values.length > 8;

        if (useDropdown) {
          const selectWrapper = document.createElement('div');
          selectWrapper.className = 'qb-select-wrapper';
          const select = document.createElement('select');
          select.className = 'qb-option-select';
          select.dataset.optionIndex = optionIndex;
          option.values.forEach(value => {
            const opt = document.createElement('option');
            opt.value = value;
            opt.textContent = value;
            select.appendChild(opt);
          });
          select.addEventListener('change', (e) => {
            this.selectOption(optionIndex, e.target.value);
          });
          selectWrapper.appendChild(select);
          group.appendChild(selectWrapper);
        } else {
          const valuesDiv = document.createElement('div');
          valuesDiv.className = 'qb-option-values';
          option.values.forEach(value => {
            const isAvailable = productData.variants.some(v =>
              v.options[optionIndex] === value && v.available
            );
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'qb-option-btn' + (isAvailable ? '' : ' unavailable');
            btn.textContent = value + (isAvailable ? '' : ' – Sold out');
            btn.dataset.optionIndex = optionIndex;
            btn.dataset.value = value;
            if (!isAvailable) btn.setAttribute('aria-disabled', 'true');
            valuesDiv.appendChild(btn);
          });
          group.appendChild(valuesDiv);
        }

        variantsContainer.appendChild(group);
      });

      if (preSelectedVariantId) {
        const variant = productData.variants.find(v => v.id == preSelectedVariantId);
        if (variant) {
          variant.options.forEach((value, index) => this.selectOption(index, value));
        } else {
          this.selectDefaultVariant();
        }
      } else {
        this.selectDefaultVariant();
      }

      this.modal.classList.add('active');
      document.body.style.overflow = 'hidden';
    },

    closeModal() {
      this.modal.classList.remove('active');
      document.body.style.overflow = '';
    },

    selectDefaultVariant() {
      const available = this.currentProduct.variants.find(v => v.available);
      if (available) available.options.forEach((value, index) => this.selectOption(index, value));
    },

    selectOption(optionIndex, value) {
      this.modal.querySelectorAll('.qb-option-btn[data-option-index="' + optionIndex + '"]').forEach(btn => {
        if (!btn.classList.contains('unavailable')) {
          btn.classList.toggle('selected', btn.dataset.value === value);
        }
      });
      this.updateSelectedVariant();
    },

    updateSelectedVariant() {
      const selectedOptions = [];
      this.modal.querySelectorAll('.qb-option-group').forEach((group, index) => {
        const sel = group.querySelector('.qb-option-btn.selected');
        const selectEl = group.querySelector('.qb-option-select');
        if (sel) selectedOptions[index] = sel.dataset.value;
        else if (selectEl) selectedOptions[index] = selectEl.value;
      });

      this.selectedVariant = this.currentProduct.variants.find(v =>
        v.options.every((opt, i) => opt === selectedOptions[i])
      );

      const addBtn = this.modal.querySelector('.qb-add-btn');
      const priceEl = this.modal.querySelector('.qb-modal-price');
      const imgEl = this.modal.querySelector('.qb-modal-image');
      const qtyInput = this.modal.querySelector('.qb-quantity-input');
      const minusBtn = this.modal.querySelector('.qb-quantity-minus');
      const plusBtn = this.modal.querySelector('.qb-quantity-plus');

      if (this.selectedVariant) {
        priceEl.textContent = this.formatMoney(this.selectedVariant.price);
        addBtn.disabled = !this.selectedVariant.available;
        addBtn.textContent = this.selectedVariant.available ? this.defaultBtnText : 'Sold out';

        const inventoryMap = this.inventoryCache[this.currentProductId] || {};
        const stockQty = inventoryMap[this.selectedVariant.id] !== undefined
          ? inventoryMap[this.selectedVariant.id]
          : 999;

        const alreadyInCart = (this._cartQuantities && this._cartQuantities[this.selectedVariant.id]) || 0;
        const cartRemaining = Math.max(0, this._cartLimit - alreadyInCart);
        const maxQty = Math.min(stockQty, cartRemaining);
        const minQty = 1;

        qtyInput.min = minQty;
        qtyInput.max = maxQty;
        let currentVal = parseInt(qtyInput.value) || 1;
        if (currentVal < minQty) currentVal = minQty;
        if (currentVal > maxQty) currentVal = maxQty;
        qtyInput.value = currentVal;
        minusBtn.disabled = currentVal <= minQty;
        plusBtn.disabled = currentVal >= maxQty;

        if (maxQty <= 0) {
          addBtn.disabled = true;
          addBtn.textContent = 'Limit reached';
        }

        const imgSrc = this.selectedVariant.featured_image
          ? this.selectedVariant.featured_image.src
          : (this.currentProduct.images.length > 0 ? this.currentProduct.images[0].src : null);
        if (imgSrc) {
          imgEl.src = imgSrc;
          imgEl.alt = this.selectedVariant.title;
          imgEl.style.display = 'block';
        } else {
          imgEl.style.display = 'none';
        }
      }
    },

    async addToCart(variantId, quantity) {
      const errorEl = this.modal ? this.modal.querySelector('.qb-error') : null;
      if (errorEl) errorEl.classList.remove('visible');

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: quantity })
        });

        if (!res.ok) {
          const errData = await res.json();
          const msg = errData.description || errData.message || 'Unable to add to cart. Please try again.';
          if (errorEl) { errorEl.textContent = msg; errorEl.classList.add('visible'); }
          return false;
        }

        const data = await res.json();

        // Refresh Horizon cart bubble count
        fetch('/?sections=cart-bubble')
          .then(r => r.json())
          .then(sections => {
            if (sections['cart-bubble']) {
              const parser = new DOMParser();
              const doc = parser.parseFromString(sections['cart-bubble'], 'text/html');
              const newBubble = doc.querySelector('.cart-bubble');
              const existingBubble = document.querySelector('.cart-bubble');
              if (newBubble && existingBubble) existingBubble.outerHTML = newBubble.outerHTML;
            }
          });

        // Open Horizon cart drawer
        this.openCartDrawer();

        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: data, data: { variantId: variantId, itemCount: data.quantity } }
        }));

        return true;

      } catch(err) {
        if (errorEl) {
          errorEl.textContent = 'Unable to add to cart. Please try again.';
          errorEl.classList.add('visible');
        }
        return false;
      }
    },

    openCartDrawer() {
      const drawerEl = document.querySelector('cart-drawer-component');
      if (drawerEl && typeof drawerEl.open === 'function') {
        drawerEl.open();
      }
    },

    formatMoney(cents) {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(cents / 100);
    }
  };

  window.QB.init();
}
